export const previewPages = [
  {
    page: 3,
    title: 'Your 12-lesson roadmap',
    description: 'See the full teaching sequence and what to observe before choosing your next lesson.',
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792070893370_handball-page-03.webp',
  },
  {
    page: 13,
    title: 'Passing and moving, ready to teach',
    description: 'See the setup, timed activities, coaching cue and movement diagram together.',
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792070895176_handball-page-13.webp',
  },
  {
    page: 25,
    title: 'From skills to small-sided games',
    description: 'See how a 3v3 scoring-zone game is organized and explained.',
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792070896277_handball-page-25.webp',
  },
  {
    page: 33,
    title: 'A plan for larger classes',
    description: 'See practical organization options for 24, 30, 36 and 40 players.',
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792070897372_handball-page-33.webp',
  },
  {
    page: 39,
    title: 'Simple observation and assessment',
    description: 'See the printable recording sheet and clear observation indicators.',
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/29b0aff5-3e15-4f58-859e-017d981df68e/1792070898722_handball-page-39.webp',
  },
];
